<template>
  <score-main @back="goBack">
    <template slot="nav">
      <div class="scoreNav">
        <p>
          <span v-if="classInfo.is_special_train === 1">【快】</span>
          {{classInfo.class_name}}
        </p>
      </div>
    </template>
    <template slot="main">
      <div class="scoreMain">
        <div class="content">
          <div v-if="showList" class="scrollArea">
            <vue-scroll :ops="ops">
              <div class="table">
                <div v-for="(item, index) in formVal" :class="{
                  item:true,
                  exam_border:item.border,
                  repetition_stu: item.student_information === 'verify' && classInfo.is_restrict_stu_info === 0,
                  item_border:!(item.student_information === 'verify' && classInfo.is_restrict_stu_info === 0)}"
                  :title="item.student_information | tipMsg(classInfo.is_restrict_stu_info)">
                  <div v-if="item.border" class="exam_stu" >
                    <div class="dash_line "></div>
                    <div class="dash_content">补考人员</div>
                    <div class="dash_line"></div>
                  </div>
                  <div class="row up">
                    <div class="col user">
                      <div class="num" v-if="!item.enroll_type">{{index + 1}}</div>
                      <div class="num" v-else-if="item.enroll_type==='common'">{{index + 1}}</div>
                      <div class="num" v-else>{{ examObj[index] }}</div>
<!--                      <div class="num" v-if="item.enroll_type==='common'">{{index+1}}</div>-->
<!--                      <div class="num" v-else>{{ examObj[index] }}</div>-->
                      <img :src="item.user_img||User" alt="" @error="userImgError(index)" @click="viewDetail(item.uid)">
                      <div class="wrap">
                        <p class="name">{{item.user_name}}</p>
                        <!--<div class="btn" @click="lookTutorial(item.user_id)">查看教案</div>-->
                        <router-link class="btn" target="_blank" :to="{path: 'stu_tutorial', query: {user_id: item.uid, c_id: c_id, home: true}}">
                          查看教案
                        </router-link>
                      </div>
                    </div>
                    <div class="col info">
                      <div class="title">
                        <p>基</p>
                        <p>本</p>
                        <p>信</p>
                        <p>息</p>
                      </div>
                      <div class="block">
                        <div class="line">
                          <p>证件号：{{item.id_number}}</p>
                        </div>
                        <div class="line">
                          <p>
                            <span>性别 : {{item.gender|getGender}}</span>
                            <span>手机 : {{item.mobile_phone}}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col note">
                      <div class="title">
                        <p>备</p>
                        <p>注</p>

                      </div>
                      <textarea v-model="item.remark" :placeholder="note" :disabled="item.student_information === 'verify' && classInfo.is_restrict_stu_info === 0"></textarea>
                    </div>
                    <div class="col average" v-if="item.enroll_type==='common'">
                      <div class="title">
                        <p>综合</p>
                        <p>平均</p>
                        <p>成绩</p>
                      </div>
                      <div class="score">
                        <p>{{item.practice_avg_points || '--'}}</p>
                      </div>
                    </div>
                    <div class="col grade">
                      <div class="title">
                        <p>成</p>
                        <p>绩</p>
                      </div>
                      <div class="score">
                        <p :class="{
                        'pass': item.results_status === 'pass',
                        'fail': (item.results_status === 'fail') || (item.student_information === 'verify' && classInfo.is_restrict_stu_info === 0)
                        }">
                            <span v-if="item.student_information === 'verify' && classInfo.is_restrict_stu_info === 0">
                            {{'fail' | showScore}}
                            </span>
                            <span v-else>
                              {{item.results_status|showScore}}
                            </span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="row down">
                    <div class="col" v-for="col in item.scoreArr">
                      <span>{{col.achievement_subject_des}}</span>
                      <score-input :val.sync="col.achievement_score"
                                   :title.sync="col.achievement_subject_des"
                                   :err.sync="col.err"
                                   :type="item.enroll_type"
                                   :disabled_status="item.student_information === 'verify' && classInfo.is_restrict_stu_info === 0"
                                   @change="getScore(index)"></score-input>
                    </div>
                    <div class="col" v-if="classInfo.class_level === 'D'">
                      <span>综合*</span>
                      <p class="total">{{(item.total_points || item.total_points === 0) ? `${item.total_points}分`: ""}}</p>
                    </div>
                  </div>
                  <el-row v-if="showTotal && item.showTotal && (classInfo.class_level==='B'|| classInfo.class_level==='A' )"
                          class="score-result totalCommonStu  " :class="item.border ? null :'nolineTotal'">
                    <el-col :span="6" class="result-col">学员人数：{{commonStuList.length}}</el-col>
                    <el-col :span="6" class="result-col">通过：{{passNum}}</el-col>
                    <el-col :span="6" class="result-col">未通过：{{fail}}</el-col>
                    <el-col :span="6" class="result-col">实践课补考：{{commonStuList.length- passNum - fail}}</el-col>
                  </el-row>
                </div>
                <template v-if="classInfo.class_level==='C' ||  classInfo.class_level==='D'">
                  <el-row v-if="showTotal"
                          class="score-result">
                    <el-col :span="8" class="result-col">学员人数：{{formVal.length}}</el-col>
                    <el-col :span="8" class="result-col">通过：{{passNum}}</el-col>
                    <el-col :span="8" class="result-col">未通过：{{formVal.length-passNum}}</el-col>
                  </el-row>
                </template>
              </div>
            </vue-scroll>
          </div>
        </div>
        <div class="btns">
          <div class="btn success"
               @click="previewScore">预览</div>
          <div class="btn success"
               @click="tempUpload">{{role_type === 'teacher' ? '暂时保存' : '保存' }}</div>
          <div class="btn success"
               @click="nextStep">下一步(培训班报告)</div>
          <div class="btn error"
               @click="goBack">取消</div>
        </div>
        <yioks-tips :tips="backWarn.tips"
                    :showTips="backWarn.flag"
                    @hideTips="hideBackTips"></yioks-tips>
        <yioks-tips :tips="uploadWarn.tips"
                    :showTips="uploadWarn.flag"
                    :loading="loading"
                    @hideTips="hideUploadTips"></yioks-tips>
        <yioks-tips :tips="nextWarn.tips"
                    :showTips="nextWarn.flag"
                    :loading="loading"
                    @hideTips="hideNextTips"></yioks-tips>
        <el-dialog
            class="detail-info-dia preview-score"
            title="成绩预览"
            :visible.sync="showPreScore"
            :close-on-click-modal="false"
            width="900px"
            top="10vh"
        >
          <div class="scroll-wrap">
            <vue-scroll :ops="disScrollOpt" ref="vScroll">
              <div class="table">
                <div v-for="(item, index) in formVal" class="item"
                :class="{
                exam_border:item.border,
                }">
                  <div v-if="item.border" class="exam_stu " >
                    <div class="dash_line black_boder"></div>
                    <div class="dash_content">补考人员</div>
                    <div class="dash_line black_boder"></div>
                  </div>
                  <el-row v-if="showTotal && item.showTotal && (classInfo.class_level==='B'|| classInfo.class_level==='A' ) "
                          class="score-result totalCommonStu" :class="item.border ? null :'nolineTotal'">
                    <el-col :span="6" class="result-col">学员人数：{{commonStuList.length}}</el-col>
                    <el-col :span="6" class="result-col">通过：{{passNum}}</el-col>
                    <el-col :span="6" class="result-col">未通过：{{fail}}</el-col>
                    <el-col :span="6" class="result-col">实践课补考：{{commonStuList.length- passNum - fail}}</el-col>
                  </el-row>
                  <div class="row up">
                    <div class="col user">
                      <div class="num" v-if="!item.enroll_type">{{index + 1}}</div>
                      <div class="num" v-else-if="item.enroll_type==='common'">{{index + 1}}</div>
                      <div class="num" v-else>{{ examObj[index] }}</div>
                      <img :src="item.user_img||User" alt="" @error="userImgError(index)">
                      <div class="wrap">
                        <p class="name">{{item.user_name}}</p>
                      </div>
                    </div>
                    <div class="col info">
                      <div class="title">
                        <p>基</p>
                        <p>本</p>
                        <p>信</p>
                        <p>息</p>
                      </div>
                      <div class="block">
                        <div class="line">
                          <p>证件号 : {{item.id_number}}</p>
                        </div>
                        <div class="line">
                          <p>
                            <span>性别 : {{item.gender|getGender}}</span>
                            <span>手机 : {{item.mobile_phone}}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col note">
                      <div class="title">
                        <p>备</p>
                        <p>注</p>
                      </div>
                      <textarea v-model="item.remark || '暂无备注'"
                                :disabled="true"></textarea>
                    </div>
                    <div class="col average" v-if="item.enroll_type==='common'">
                      <div class="title">
                        <p>综合</p>
                        <p>平均</p>
                        <p>成绩</p>
                      </div>
                      <div class="score">
                        <p>{{item.practice_avg_points || '--'}}</p>
                      </div>
                    </div>
                    <div class="col grade">
                      <div class="title">
                        <p>成</p>
                        <p>绩</p>
                      </div>
                      <div class="score">
                        <p :class="{
                        'pass': item.results_status === 'pass',
                        'fail': (item.results_status === 'fail') || (item.student_information === 'verify' && classInfo.is_restrict_stu_info === 0)
                        }">
                          <span v-if="item.student_information === 'verify' && classInfo.is_restrict_stu_info === 0">
                            未通过
                            </span>
                          <span v-else>
                              {{item.results_status|showScore}}
                            </span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="row down">
                    <div class="col" v-for="col in item.scoreArr">
                      <span>{{col.achievement_subject_des}}</span>
                      <span>{{col.achievement_score | preScore}}</span>
                    </div>
                    <div class="col" v-if="classInfo.class_level === 'D'">
                      <span>综合*</span>
                      <span>{{item.total_points | preScore}}</span>
                    </div>
                  </div>
                </div>
                <template v-if="classInfo.class_level==='C' ||  classInfo.class_level==='D'">
                  <el-row v-if="showTotal"
                          class="score-result">
                    <el-col :span="8" class="result-col">学员人数：{{formVal.length}}</el-col>
                    <el-col :span="8" class="result-col">通过：{{passNum}}</el-col>
                    <el-col :span="8" class="result-col">未通过：{{formVal.length-passNum}}</el-col>
                  </el-row>
                </template>
              </div>
            </vue-scroll>
          </div>
        </el-dialog>
        <el-dialog
            class="detail-info-dia stu-info"
            title="详细信息"
            :visible.sync="ifDiaShow"
            :close-on-click-modal="false"
            width="750px"
            top="12vh"
        >
          <div class="scroll-wrap">
            <vue-scroll :ops="disScrollOpt" ref="vScroll">
              <div class="stu-info-box">
                <stu-detail-info :uid='stuUid'
                                 :cid="c_id"></stu-detail-info>
              </div>
            </vue-scroll>
          </div>
        </el-dialog>
      </div>
    </template>
  </score-main>
</template>

<script>
  import scoreMixin from "@/minix/score";

  export default {
    name: "upload-score",
    mixins: [scoreMixin],
  }
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable';
  @import '~@/assets/css/mixin';

  .scoreNav {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    font-size: $font_size_big;
  }
  .scoreMain {
    width: 100%;
    height: 100%;
    .content {
      height: 92%;
      box-sizing: border-box;
      padding: 15px 0 15px 20px;
      background-color: $block_bg_color_base;
      .scrollArea {
        width: 100%;
        height: 100%;
        .table {
          padding: 0 20px 20px 0;
          .item {
            margin: 0 0 20px 0;
            .row {
              display: flex;
              position: relative;
              .col {
                flex: 1 1 auto;
                border-right: 1px solid $color_white;
                &:last-child {
                  border-right: none;
                }
              }
              &.up {
                // height: 80px;
                border-bottom: 1px solid $color_white;
                .col {
                  // height: 100%;
                  &.user {
                    width: 25%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: relative;
                    padding-left:8px;
                    .num {
                      position: absolute;
                      top: 3px;
                      left: 5px;
                    }
                    img {
                      flex: 0 0 auto;
                      width: 60px;
                      height: 60px;
                      border-radius: 50%;
                      cursor: pointer;
                    }
                    .wrap {
                      // height: 100%;
                      margin: 0 0 0 12px;
                      display: flex;
                      flex-direction: column;
                      justify-content: space-around;
                      align-items: center;
                      width 100%
                      .name {
                        font-size: $font_size_medium;
                        // word-break break-word
                        word-break break-all
                        word-wrap break-word
                        margin-bottom 5px
                        width 100%
                        text-align center
                      }
                      .btn {
                        padding: 5px 15px;
                        background-color: $color_suc;
                        border-radius: 5px;
                        cursor: pointer;
                        user-select: none;
                      }
                    }
                  }
                  title() {
                    flex: 0 0 auto;
                    width: 30px;
                    // height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    border-right: 1px solid $color_white;
                  }
                  &.info {
                    width: 33%;
                    display: flex;
                    .title {
                      title();
                    }
                    .block {
                      flex: 1 1 auto;
                      display: flex;
                      flex-direction: column;
                      .line {
                        flex: 1 1 auto;
                        /*padding: 0 0 0 20px;*/
                        /*padding: 0 0 0 2px;*/
                        display: flex;
                        align-items: center;
                        font-size: $font_size_base;
                        border-bottom: 1px solid $color_white;
                        &:last-child {
                          border-bottom: none;
                        }
                        span:first-child {
                          margin: 0 5px 0 0;
                        }
                      }
                    }
                  }
                  &.note {
                    width: 25%;
                    display: flex;
                    align-items: center;
                    .title {
                      title();
                      align-self stretch
                    }
                    textarea {
                      flex: 1 1 auto;
                      margin: 0 10px;
                      color: $color_black;
                      border-radius: 5px;
                      outline: none;
                      resize: none;
                    }
                  }
                  &.average{
                    width 15%
                    display: flex;
                    align-items: center;
                    .title {
                      title();
                      width 45px
                    }
                    .score {
                      flex: 1 1 auto;
                      text-align: center;
                    }
                  }
                  &.grade {
                    width: 17%;
                    display: flex;
                    align-items: center;
                    .title {
                      title();
                      align-self stretch
                    }
                    .score {
                      flex: 1 1 auto;
                      text-align: center;
                      font-size: $font_size_medium;
                      .pass {
                        color: $color_suc;
                      }
                      .fail {
                        color: $color_err;
                      }
                    }
                  }
                }
              }
              &.down {
                .col {
                  width: 25%;
                  padding: 10px 0 0;
                  display: flex;
                  flex-direction: column;
                  align-items center;
                  .total {
                    margin: 10px 0;
                  }
                }
              }
            }
            .nolineTotal{
              position absolute
              display flex
              align-items center
              justify-content: center;
              width: 100%;
              bottom: -60px;
            }
          }
          .score-result {
            border: 1px solid $color_white;
            .result-col {
              padding: 10px 0 10px 10px;
              border-right: 1px solid $color_white;
              &:last-child {
                border-right: none;
              }
            }
          }
        }
      }
    }
    .btns {
      height: 40px;
      margin: 10px 0 0;
      display: flex;
      justify-content: center;
      align-items: center;
      .btn {
        height: 100%;
        margin: 0 20px;
        padding: 8px 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: $font_size_medium;
        line-height: $font_size_medium;
        border-radius: 5px;
        cursor: pointer;
        user-select: none;
      }
      .success {
        background-color: $color_suc;
      }
      .error {
        background-color: $color_err;
      }
    }
    .preview-score {
      /*.score-row {
        border: 1px solid $color_black;
        .score-col {
          text-align: center;
          font-size: $font_size_big;
          border-right: 1px solid $color_black;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          &:last-child {
            border-right: none;
          }
        }
      }
      .score-head {
        padding: 0 15px;
        .score-row {
          .score-col {
            padding: 5px 0;
            font-weight: bolder;
          }
        }
      }
      .score-body {
        padding: 0 15px;
        .score-row {
          border-top: none;
          &:nth-child(even) {
            background-color: $color_text_placeholder;
          }
        }
      }*/
      .scroll-wrap {
        display: block;
        height: 630px;
        overflow: hidden;
        position: relative;
        .table {
          padding: 0 20px 20px 0;
          .item {
            margin: 0 0 20px 0;
            border: 1px solid $color_black;
            position relative
            .row {
              display: flex;
              .col {
                flex: 1 1 auto;
                border-right: 1px solid $color_black;
                &:last-child {
                  border-right: none;
                }
              }
              &.up {
                height: 80px;
                border-bottom: 1px solid $color_black;
                .col {
                  height: 100%;
                  &.user {
                    width: 25%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: relative;
                    padding-left:8px;
                    .num {
                      position: absolute;
                      top: 3px;
                      left: 5px;
                    }
                    img {
                      flex: 0 0 auto;
                      width: 60px;
                      height: 60px;
                      border-radius: 50%;
                    }
                    .wrap {
                      height: 100%;
                      margin: 0 0 0 20px;
                      display: flex;
                      flex-direction: column;
                      justify-content: space-around;
                      align-items: center;
                      width 100%
                      .name {
                        font-size: $font_size_medium;
                        width:100%;
                        text-align:center;
                      }
                      .btn {
                        padding: 5px 15px;
                        background-color: $color_suc;
                        border-radius: 5px;
                        cursor: pointer;
                        user-select: none;
                      }
                    }
                  }
                  title() {
                    flex: 0 0 auto;
                    width: 30px;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    border-right: 1px solid $color_black;
                  }
                  &.info {
                    width: 33%;
                    display: flex;
                    .title {
                      title();
                    }
                    .block {
                      flex: 1 1 auto;
                      display: flex;
                      flex-direction: column;
                      .line {
                        flex: 1 1 auto;
                        /*padding: 0 0 0 20px;*/
                        /*padding: 0 0 0 2px;*/
                        display: flex;
                        align-items: center;
                        font-size: $font_size_base;
                        border-bottom: 1px solid $color_black;
                        &:last-child {
                          border-bottom: none;
                        }
                        span:first-child {
                          margin: 0 5px 0 0;
                        }
                      }
                    }
                  }
                  &.note {
                    width: 25%;
                    display: flex;
                    align-items: center;
                    .title {
                      title();
                    }
                    textarea {
                      flex: 1 1 auto;
                      margin: 0 10px;
                      border-radius: 5px;
                      outline: none;
                      resize: none;
                    }
                  }
                  &.average{
                    width 15%
                    display: flex;
                    align-items: center;
                    .title {
                      title();
                      width 45px
                    }
                    .score {
                      flex: 1 1 auto;
                      text-align: center;
                    }
                  }
                  &.grade {
                    width: 17%;
                    display: flex;
                    align-items: center;
                    .title {
                      title();
                    }
                    .score {
                      flex: 1 1 auto;
                      text-align: center;
                      font-size: $font_size_medium;
                      .pass {
                        color: $color_suc;
                      }
                      .fail {
                        color: $color_err;
                      }
                    }
                  }
                }
              }
              &.down {
                .col {
                  width: 25%;
                  padding: 5px 0 0;
                  display: flex;
                  flex-direction: column;
                  align-items center;
                  .total {
                    margin: 10px 0;
                  }
                }
              }
            }
            .nolineTotal{
              position absolute
              display flex
              align-items center
              justify-content: center;
              width: 100%;
              bottom: -60px;
            }
          }
          .score-result {
            border: 1px solid $color_black;
            .result-col {
              padding: 10px 0 10px 10px;
              border-right: 1px solid $color_black;
              &:last-child {
                border-right: none;
              }
            }
          }
        }
      }
    }
    .stu-info {
      .scroll-wrap {
        display: block;
        height: 530px;
        overflow: hidden;
        position: relative;
        .stu-info-box {
          display: block;
          padding: 0 15px;
          font-size: $font_size_medium;
        }
      }
    }
    .repetition_stu {
      border: 1px solid $color_err;
    }
    .item_border{
      border: 1px solid $color_white;
      position relative
    }
    .exam_border{
      margin-top 100px !important
      position relative
      .exam_stu{
        position absolute
        width 100%
        top: -30px
        display flex
        align-items center
        .dash_line{
          width 45%
          height 0
          border 1px dashed $color_white
        }
        .black_boder{
          border 1px dashed $color_black
        }
        .dash_content{
          font-size 18px
          text-align center
          width 10%
        }
      }
      .totalCommonStu{
        position: absolute;
        width: 100%;
        top: -84px;
        display: flex;
        align-items: center;
      }
  }
  }
</style>
